const maxLength = 1000;

const stageOfProject = [
  {
    id: 'idea-concept',
    value: 'idea-concept',
    displayedValue: 'I have an idea / Concept stage',
    description:
      'You have a basic idea but no designs or technical documents yet.',
  },
  {
    id: 'design',
    value: 'design',
    displayedValue: 'I have a Design / Prototype',
    description:
      'You already have wireframes or UI designs, maybe even a clickable prototype.',
  },
  {
    id: 'documentation',
    value: 'documentation',
    displayedValue: 'I have a full documentation / Tech Spec available',
    description:
      'You have a clear technical specification or requirements document prepared.',
  },
  {
    id: 'upgrade',
    value: 'upgrade',
    displayedValue: 'I have an existing version (Redesign / Upgrade)',
    description:
      'You already built a version of the product and need to improve or redesign it.',
  },
];

const time = [
  { id: 'not-sure-time', value: 'Not sure', icon: 'ic-question' },
  { id: '1-3-months', value: '1-3 months', icon: 'ic-clock' },
  { id: '6-months', value: '6 months', icon: 'ic-clock' },
  { id: '12-months', value: '12 months', icon: 'ic-clock' },
  { id: '24-months', value: '24+ months', icon: 'ic-clock' },
];

const budget = [
  { id: 'not-sure-budget', value: 'Not sure', icon: 'ic-question' },
  { id: '3-10K', value: '€3–10K', icon: 'ic-dollar' },
  { id: '11-50K', value: '€11–50K', icon: 'ic-dollar' },
  { id: '51-150K', value: '€51–150K', icon: 'ic-dollar' },
  { id: '160K', value: '€160K+', icon: 'ic-dollar' },
];

export { budget, maxLength, stageOfProject, time };
